import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Avatar from 'flarum/common/components/Avatar';
import username from 'flarum/common/helpers/username';
import HeaderList from 'flarum/forum/components/HeaderList';
import HeaderListItem from 'flarum/forum/components/HeaderListItem';
import ItemList from 'flarum/common/utils/ItemList';
import ProcessErasureRequestModal from './ProcessErasureRequestModal';
export default class ErasureRequestsList extends Component {
  view() {
    const state = this.attrs.state;
    return m(HeaderList, {
      className: "ErasureRequestsList",
      title: app.translator.trans('flarum-gdpr.forum.erasure_requests.title'),
      controls: this.controlItems(),
      hasItems: state.hasItems(),
      loading: state.isLoading(),
      emptyText: app.translator.trans('flarum-gdpr.forum.erasure_requests.empty_text'),
      loadMore: () => state.hasNext() && !state.isLoadingNext() && state.loadNext()
    }, m("ul", {
      className: "HeaderListGroup-content"
    }, this.content(state)));
  }
  showModal(request) {
    app.modal.show(ProcessErasureRequestModal, {
      request
    });
  }
  controlItems() {
    const items = new ItemList();
    return items;
  }
  content(state) {
    if (!state.isLoading() && state.hasItems()) {
      return state.getPages().map(page => {
        return page.items.map((request, index) => {
          return m("li", null, m(HeaderListItem, {
            key: index,
            className: "EraseRequest",
            onclick: this.showModal.bind(this, request),
            avatar: m(Avatar, {
              user: request.user()
            }),
            icon: "fas fa-user-edit",
            content: app.translator.trans("flarum-gdpr.forum.erasure_requests.item_text", {
              name: username(request.user())
            }),
            datetime: request.createdAt(),
            excerpt: ""
          }));
        });
      });
    }
    return null;
  }
}
flarum.reg.add('flarum-gdpr', 'forum/components/ErasureRequestsList', ErasureRequestsList);